import { ApiError } from '@/lib/api';

/** An API refusal, ready for a page: the sentence, the id to quote, and per-field messages. */
export interface Problem {
  message: string;
  requestId: string | undefined;
  fields: Record<string, string>;
}

export function toProblem(error: unknown): Problem {
  if (error instanceof ApiError) {
    return {
      message: error.message,
      requestId: error.requestId,
      fields: Object.fromEntries(error.fieldErrors.map((f) => [f.field, f.message])),
    };
  }
  return { message: 'The request could not be completed.', requestId: undefined, fields: {} };
}

/** Spread onto an Input: `{...fieldError(problem, 'email')}`, which sets nothing when clean. */
export function fieldError(problem: Problem | null, field: string): { error?: string } {
  const message = problem?.fields[field];
  return message ? { error: message } : {};
}
